/* eslint-disable */
import type {DocumentNode} from 'graphql';
import * as ApolloReactHooks from '@apollo/client/react';
import type {WikiArticlesQuery, WikiArticlesQueryVariables} from '../types';

export const WikiArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WikiArticles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wikiArticles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"originalTitle"}},{"kind":"Field","name":{"kind":"Name","value":"types"}}]}}]}}]} as unknown as DocumentNode;
/** hook для запроса "WikiArticles" */
export function useWikiArticlesQuery(
    baseOptions?: ApolloReactHooks.QueryHookOptions<WikiArticlesQuery, WikiArticlesQueryVariables>,
) {
    return ApolloReactHooks.useQuery<WikiArticlesQuery, WikiArticlesQueryVariables>(
        WikiArticlesDocument,
        baseOptions ?? ({} as ApolloReactHooks.QueryHookOptions<WikiArticlesQuery, WikiArticlesQueryVariables>),
    );
}
